import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import SimplePeer from 'simple-peer';
import { io } from 'socket.io-client';
import useStore from '../store/useStore';
import toast from 'react-hot-toast';

const SOCKET_URL = 'https://qtalk.qualtechedge.in';

const ICE_CONFIG = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
    { urls: ['turn:35.154.186.85:3478', 'turn:35.154.186.85:3478?transport=tcp'], username: 'qtalk', credential: 'Qtalk@2026' }
  ]
};

const S = {
  root: { height:'100vh', display:'flex', flexDirection:'column', background:'#0d1117', overflow:'hidden', fontFamily:'system-ui,-apple-system,sans-serif', color:'#e6edf3' },
  // header
  hdr: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 16px', height:48, background:'#161b22', borderBottom:'1px solid rgba(255,255,255,0.08)', flexShrink:0 },
  hdrLeft: { display:'flex', alignItems:'center', gap:10 },
  logoMark: { width:28, height:28, borderRadius:8, background:'linear-gradient(135deg,#0d9488,#2563eb)', display:'flex', alignItems:'center', justifyContent:'center' },
  logoText: { fontSize:13, fontWeight:600, color:'#e6edf3' },
  meetIdText: { fontSize:11, color:'#6e7681', fontFamily:'monospace' },
  hdrCenter: { display:'flex', flexDirection:'column', alignItems:'center', gap:1 },
  durText: { fontSize:15, fontWeight:600, color:'#e6edf3', letterSpacing:'0.5px', fontFamily:'monospace' },
  pcountText: { fontSize:10, color:'#8b949e', letterSpacing:'0.06em', textTransform:'uppercase' },
  hdrRight: { display:'flex', alignItems:'center', gap:6 },
  hdrBtn: { display:'flex', alignItems:'center', gap:5, padding:'5px 10px', borderRadius:7, border:'1px solid rgba(255,255,255,0.08)', background:'transparent', color:'#8b949e', cursor:'pointer', fontSize:11, fontWeight:500 },
  hdrBtnEnt: { display:'flex', alignItems:'center', gap:5, padding:'5px 10px', borderRadius:7, border:'1px solid rgba(13,148,136,0.4)', background:'transparent', color:'#0d9488', cursor:'pointer', fontSize:11, fontWeight:500 },
  recDot: { width:6, height:6, borderRadius:'50%', background:'#ef4444' },
  // body
  body: { display:'flex', flex:1, overflow:'hidden' },
  main: { flex:1, display:'flex', flexDirection:'column', padding:10, gap:8, overflow:'hidden', minWidth:0 },
  mainSharing: { flex:1, display:'flex', flexDirection:'row', padding:10, gap:8, overflow:'hidden', minWidth:0 },
  // share panel
  sharePanel: { flex:1, background:'#000', borderRadius:12, border:'1px solid rgba(13,148,136,0.35)', overflow:'hidden', display:'flex', flexDirection:'column', position:'relative', minWidth:0 },
  sharePanelHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 12px', background:'rgba(13,148,136,0.1)', borderBottom:'1px solid rgba(13,148,136,0.2)' },
  shareBadge: { fontSize:10, fontWeight:600, padding:'2px 8px', borderRadius:20, background:'#0d9488', color:'#fff', letterSpacing:'0.04em', textTransform:'uppercase' },
  shareName: { fontSize:12, fontWeight:500, color:'#e6edf3', marginLeft:8 },
  shareCtrlBtn: { width:26, height:26, borderRadius:6, border:'1px solid rgba(255,255,255,0.08)', background:'#21262d', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'#8b949e' },
  shareVideo: { flex:1, position:'relative', background:'#000', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' },
  // thumb strip
  thumbStrip: { height:120, display:'flex', gap:6, flexShrink:0, overflowX:'auto', padding:'4px 2px' },
  thumbStripV: { width:180, display:'flex', flexDirection:'column', gap:6, flexShrink:0, overflowY:'auto', padding:'4px 2px' },
  thumb: { flex:1, borderRadius:10, background:'#161b22', border:'1px solid rgba(255,255,255,0.08)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:5, position:'relative', overflow:'hidden', cursor:'pointer' },
  thumbV: { height:120, flexShrink:0, borderRadius:10, background:'#161b22', border:'1px solid rgba(255,255,255,0.08)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:5, position:'relative', overflow:'hidden', cursor:'pointer' },
  thumbName: { fontSize:9, color:'#8b949e', textAlign:'center', maxWidth:'90%', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  thumbBadge: { position:'absolute', top:5, right:5, display:'flex', gap:3 },
  tIcon: { width:14, height:14, borderRadius:3, display:'flex', alignItems:'center', justifyContent:'center' },
  // grid (no share)
  gridWrap: { flex:1, padding:8, display:'grid', gap:6, alignItems:'stretch', overflow:'hidden' },
  gridTile: { position:'relative', background:'#21262d', borderRadius:12, overflow:'hidden', border:'1px solid rgba(255,255,255,0.06)', minHeight:0 },
  tileAvatar: { position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:8, background:'#161b22' },
  // right panel
  rightPanel: { width:252, flexShrink:0, background:'#161b22', borderLeft:'1px solid rgba(255,255,255,0.08)', display:'flex', flexDirection:'column', overflow:'hidden' },
  panelTabs: { display:'flex', borderBottom:'1px solid rgba(255,255,255,0.08)', flexShrink:0 },
  // participant card
  pcard: { background:'#21262d', borderRadius:10, border:'1px solid rgba(255,255,255,0.08)', padding:10, marginBottom:8 },
  pcardHost: { background:'#21262d', borderRadius:10, border:'1px solid rgba(13,148,136,0.3)', padding:10, marginBottom:8 },
  pcAvatar: { width:36, height:36, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600, color:'#fff', flexShrink:0, position:'relative' },
  pcName: { fontSize:12, fontWeight:600, color:'#e6edf3', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  pcRole: { fontSize:10, color:'#8b949e', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  badge: { fontSize:9, padding:'2px 6px', borderRadius:4, fontWeight:500 },
  stateChip: { display:'flex', alignItems:'center', gap:4, padding:'3px 7px', borderRadius:5, fontSize:10, fontWeight:500 },
  // waiting
  waitCard: { background:'rgba(239,68,68,0.08)', borderRadius:9, border:'1px solid rgba(239,68,68,0.2)', padding:9, marginBottom:7 },
  waitAvatar: { width:26, height:26, borderRadius:7, background:'rgba(239,68,68,0.3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:600, color:'#fff' },
  wBtn: { flex:1, padding:5, borderRadius:6, border:'none', fontSize:10, fontWeight:600, cursor:'pointer' },
  // reactions
  rxnBar: { display:'flex', alignItems:'center', justifyContent:'center', gap:6, padding:'5px 16px', flexShrink:0, background:'#0d1117', borderTop:'1px solid rgba(255,255,255,0.05)' },
  rxnBtn: { padding:'4px 10px', borderRadius:20, border:'1px solid rgba(255,255,255,0.08)', background:'#21262d', cursor:'pointer', fontSize:14, position:'relative' },
  // controls
  controls: { display:'flex', alignItems:'center', justifyContent:'center', gap:6, padding:'8px 16px', background:'#161b22', borderTop:'1px solid rgba(255,255,255,0.08)', flexShrink:0 },
  ctrlBtn: { display:'flex', flexDirection:'column', alignItems:'center', gap:3, padding:'7px 12px', borderRadius:10, border:'none', cursor:'pointer', minWidth:58, background:'#21262d', color:'#e6edf3' },
  ctrlBtnActive: { display:'flex', flexDirection:'column', alignItems:'center', gap:3, padding:'7px 12px', borderRadius:10, border:'1px solid rgba(239,68,68,0.3)', cursor:'pointer', minWidth:58, background:'rgba(239,68,68,0.15)', color:'#f87171' },
  ctrlBtnShare: { display:'flex', flexDirection:'column', alignItems:'center', gap:3, padding:'7px 12px', borderRadius:10, border:'1px solid rgba(37,99,235,0.3)', cursor:'pointer', minWidth:58, background:'rgba(37,99,235,0.12)', color:'#60a5fa' },
  ctrlLabel: { fontSize:9, fontWeight:500, opacity:0.75, letterSpacing:'0.02em', whiteSpace:'nowrap' },
  ctrlDivider: { width:1, height:28, background:'rgba(255,255,255,0.1)', margin:'0 2px' },
  leaveBtn: { display:'flex', alignItems:'center', gap:6, padding:'8px 16px', borderRadius:10, border:'none', background:'#ef4444', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:12 },
  // popover
  popover: { position:'absolute', bottom:52, background:'#161b22', border:'1px solid rgba(255,255,255,0.14)', borderRadius:10, padding:6, minWidth:170, zIndex:99 },
  popItem: { display:'flex', alignItems:'center', gap:8, padding:'7px 10px', borderRadius:7, cursor:'pointer', fontSize:12, color:'#8b949e' },
};

function MicIcon({ muted, size=18 }) {
  return muted
    ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:size,height:size}}><line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6"/><path d="M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23M12 19v4M8 23h8"/></svg>
    : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:size,height:size}}><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8"/></svg>;
}
function CamIcon({ off, size=18 }) {
  return off
    ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:size,height:size}}><line x1="1" y1="1" x2="23" y2="23"/><path d="M21 21H3a2 2 0 01-2-2V8a2 2 0 012-2h3m3-3h6l2 3h4a2 2 0 012 2v9.34m-7.72-2.06a4 4 0 11-5.56-5.56"/></svg>
    : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:size,height:size}}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>;
}

export default function MeetPage() {
  const { meetId } = useParams();
  const { darkMode } = useStore();

  const getUser = () => {
    try { const s = localStorage.getItem('qtalk_user'); if (s && s !== 'undefined') return JSON.parse(s); } catch(e) {}
    return null;
  };
  const user = getUser();
  const [_guestNameFinal, setGuestNameFinal] = useState('');
  const displayName = user?.full_name || _guestNameFinal || 'Guest';
  const storedUser = (() => { try { return JSON.parse(localStorage.getItem('qtalk_user')||'{}'); } catch{ return {}; } })();
  const isHost = (user?.meet_link === meetId) || (storedUser?.meet_link === meetId);

  const [stage, setStage] = useState(user?.full_name ? 'lobby' : 'guest_name');
  const [guestName, setGuestName] = useState('');
  const [peers, setPeers] = useState([]);
  const [isMuted, setIsMuted] = useState(false);
  const [isCamOff, setIsCamOff] = useState(false);
  const [isSharing, setIsSharing] = useState(false);
  const [activePanel, setActivePanel] = useState(null); // null | 'people' | 'chat'
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [duration, setDuration] = useState(0);
  const [lobbyMuted, setLobbyMuted] = useState(false);
  const [lobbyCamOff, setLobbyCamOff] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [waitingUsers, setWaitingUsers] = useState([]);
  const [newMsgCount, setNewMsgCount] = useState(0);
  const [hostJoined, setHostJoined] = useState(false);
  const [showBgPicker, setShowBgPicker] = useState(false);
  const [virtualBg, setVirtualBg] = useState('none');
  const [remoteMuteStates, setRemoteMuteStates] = useState({});
  const [speaking, setSpeaking] = useState({});
  const [remoteSharer, setRemoteSharer] = useState(null); // socketId of peer sharing screen
  const [showEntPop, setShowEntPop] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingDuration, setRecordingDuration] = useState(0);
  const [rxnFloats, setRxnFloats] = useState([]);
  const [entActive, setEntActive] = useState(false);

  const lobbyVideoRef = useRef(null);
  const myVideoRef = useRef(null);
  const socketRef = useRef(null);
  const peersRef = useRef([]);
  const streamRef = useRef(null);
  const lobbyStreamRef = useRef(null);
  const timerRef = useRef(null);
  const analyserRefs = useRef({});
  const myAnalyserRef = useRef(null);
  const isMutedRef = useRef(false);
  const chatEndRef = useRef(null);
  const entPopRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const sharePanelVideoRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const recordingTimerRef = useRef(null);

  useEffect(() => { isMutedRef.current = isMuted; }, [isMuted]);
  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [chatMessages]);

  // Re-attach share panel video whenever remoteSharer or peer stream changes
  useEffect(() => {
    if (!remoteSharer || remoteSharer === 'me') return;
    const attachVideo = () => {
      const peer = peers.find(p => p.id === remoteSharer);
      if (!peer?.stream) return;
      const el = sharePanelVideoRef.current;
      if (el) {
        el.srcObject = peer.stream;
        el.muted = false;
        el.play().catch(() => {});
      }
    };
    attachVideo();
    // Retry a few times in case stream arrives slightly late
    const t1 = setTimeout(attachVideo, 500);
    const t2 = setTimeout(attachVideo, 1200);
    const t3 = setTimeout(attachVideo, 2500);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [remoteSharer, peers]);

  // Close ent popover on outside click
  useEffect(() => {
    const h = (e) => { if (entPopRef.current && !entPopRef.current.contains(e.target)) setShowEntPop(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const startLocalSpeakingDetection = useCallback((stream) => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const src = ctx.createMediaStreamSource(stream);
      const analyser = ctx.createAnalyser();
      analyser.fftSize = 512;
      src.connect(analyser);
      const data = new Uint8Array(analyser.frequencyBinCount);
      const interval = setInterval(() => {
        if (isMutedRef.current) { setSpeaking(p => ({ ...p, me: false })); return; }
        analyser.getByteFrequencyData(data);
        const avg = data.reduce((a, b) => a + b, 0) / data.length;
        setSpeaking(p => ({ ...p, me: avg > 15 }));
      }, 100);
      myAnalyserRef.current = { ctx, interval };
    } catch(e) {}
  }, []);

  const startRemoteSpeakingDetection = useCallback((socketId, stream) => {
    try {
      if (analyserRefs.current[socketId]) {
        clearInterval(analyserRefs.current[socketId].interval);
        try { analyserRefs.current[socketId].ctx.close(); } catch(e) {}
      }
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const src = ctx.createMediaStreamSource(stream);
      const analyser = ctx.createAnalyser();
      analyser.fftSize = 512;
      src.connect(analyser);
      const data = new Uint8Array(analyser.frequencyBinCount);
      const interval = setInterval(() => {
        analyser.getByteFrequencyData(data);
        const avg = data.reduce((a, b) => a + b, 0) / data.length;
        setSpeaking(p => ({ ...p, [socketId]: avg > 15 }));
      }, 100);
      analyserRefs.current[socketId] = { ctx, interval };
    } catch(e) {}
  }, []);

  const stopRemoteSpeakingDetection = useCallback((socketId) => {
    if (analyserRefs.current[socketId]) {
      clearInterval(analyserRefs.current[socketId].interval);
      try { analyserRefs.current[socketId].ctx.close(); } catch(e) {}
      delete analyserRefs.current[socketId];
    }
  }, []);

  useEffect(() => {
    if (stage !== 'lobby') return;
    navigator.mediaDevices?.getUserMedia({ video: true, audio: true })
      .then(stream => { lobbyStreamRef.current = stream; if (lobbyVideoRef.current) lobbyVideoRef.current.srcObject = stream; })
      .catch(() => toast.error('Allow camera/microphone access'));
    return () => {
      if (stage !== 'lobby') {
        if (lobbyStreamRef.current) { lobbyStreamRef.current.getTracks().forEach(t => t.stop()); lobbyStreamRef.current = null; }
      }
    };
  }, [stage]);

  const createPeer = (socketId, name, stream, socket, initiator, signal = null) => {
    const peer = new SimplePeer({ initiator, trickle: false, stream, config: ICE_CONFIG });
    peer.on('signal', s => {
      if (initiator) socket.emit('meet_signal', { userToSignal: socketId, callerId: socket.id, signal: s, name: displayName, avatar: user?.avatar_url || null });
      else socket.emit('meet_return_signal', { signal: s, callerId: socketId });
    });
    peer.on('connect', () => console.log('✅ Peer connected:', socketId));
    peer.on('stream', remoteStream => {
      setPeers(prev => prev.map(p => p.id === socketId ? { ...p, stream: remoteStream } : p));
      startRemoteSpeakingDetection(socketId, remoteStream);
      setTimeout(() => {
        document.querySelectorAll('audio').forEach(el => { if (el.srcObject === remoteStream && el.paused) el.play().catch(() => {}); });
      }, 500);
      // When a track is added (e.g. screen share or camera toggle via replaceTrack),
      // bump _vidVersion so video ref callbacks re-run and pick up the new track
      remoteStream.addEventListener('addtrack', () => {
        setPeers(prev => prev.map(p => p.id === socketId ? { ...p, _vidVersion: (p._vidVersion||0)+1 } : p));
      });
      // When a track is removed, bump version so UI hides video if no video tracks remain
      remoteStream.addEventListener('removetrack', () => {
        setPeers(prev => prev.map(p => p.id === socketId ? { ...p, _vidVersion: (p._vidVersion||0)+1 } : p));
      });
    });
    // Also catch individual tracks via ontrack for replaceTrack scenarios
    peer._pc && peer._pc.addEventListener('track', (e) => {
      if (e.track.kind === 'video') {
        setPeers(prev => prev.map(p => p.id === socketId ? { ...p, _vidVersion: (p._vidVersion||0)+1 } : p));
      }
    });
    peer.on('error', e => console.warn('Peer error:', e));
    if (signal) peer.signal(signal);
    return peer;
  };

  const joinMeeting = async () => {
    let stream = null;
    if (lobbyStreamRef.current && lobbyStreamRef.current.getTracks().some(t => t.readyState === 'live')) {
      stream = lobbyStreamRef.current;
    } else {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: !lobbyCamOff, audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, sampleRate: 48000, channelCount: 1 } });
      } catch(e) {
        try {
          stream = await navigator.mediaDevices.getUserMedia({ video: false, audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, sampleRate: 48000, channelCount: 1 } });
          toast('Joining with audio only');
        } catch(e2) { toast.error('Could not access camera/microphone'); return; }
      }
    }
    // Always keep a video sender in the stream so replaceTrack works later.
    // If cam is off, replace with a black canvas track instead of removing.
    if (lobbyCamOff) {
      const hasVideo = stream.getVideoTracks().length > 0;
      if (hasVideo) {
        // disable but keep the track so sender is negotiated
        stream.getVideoTracks().forEach(t => { t.enabled = false; });
      } else {
        // No video track at all — add a black canvas track so sender exists
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 640; canvas.height = 480;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = 'black'; ctx.fillRect(0, 0, 640, 480);
          const blackTrack = canvas.captureStream(1).getVideoTracks()[0];
          blackTrack.enabled = false;
          stream.addTrack(blackTrack);
        } catch(e) {}
      }
    }
    if (lobbyVideoRef.current) lobbyVideoRef.current.srcObject = null;
    stream.getAudioTracks().forEach(t => { t.enabled = true; });
    setIsMuted(lobbyMuted); setIsCamOff(lobbyCamOff);
    streamRef.current = stream;
    if (lobbyMuted) setTimeout(() => { streamRef.current?.getAudioTracks().forEach(t => { t.enabled = false; }); }, 2000);
    startLocalSpeakingDetection(stream);

    const token = localStorage.getItem('qtalk_token');
    const socket = io(SOCKET_URL, { transports: ['websocket'], auth: token ? { token } : { isGuest: true, guestName: displayName } });
    socketRef.current = socket;

    socket.on('connect', () => { socket.emit('join_meet', { meetId, name: displayName, isHost, avatar: user?.avatar_url || null }); });
    socket.on('connect_error', (e) => { toast.error('Connection failed: ' + e.message); });

    socket.on('meet_admitted', ({ users } = {}) => {
      setStage('meeting');
      setParticipants([{ name: displayName, avatar: user?.avatar_url || null, socketId: 'me' }]);
      timerRef.current = setInterval(() => setDuration(d => d + 1), 1000);
      requestAnimationFrame(() => { if (myVideoRef.current) myVideoRef.current.srcObject = stream; });
      // Broadcast initial mute state so others show correct mic icon from the start
      setTimeout(() => {
        socket.emit('meet_mute_state', { meetId, isMuted: lobbyMuted });
      }, 1500);
      if (users && users.length > 0) {
        const newPeers = users.map(u => {
          const peer = createPeer(u.socketId, u.name, stream, socket, true);
          peersRef.current.push({ peerId: u.socketId, peer, name: u.name });
          return { id: u.socketId, peer, stream: null, name: u.name, avatar: u.avatar || null };
        });
        setPeers(newPeers);
        setParticipants(prev => {
          const existing = new Set(prev.map(p => p.socketId || p.name));
          const newOnes = users.filter(u => !existing.has(u.socketId)).map(u => ({ name: u.name, avatar: u.avatar || null, socketId: u.socketId }));
          return [...prev, ...newOnes];
        });
      }
    });

    socket.on('meet_waiting', () => { setStage('waiting'); streamRef.current = stream; });
    socket.on('meet_host_joined', () => { setHostJoined(true); toast('Host has joined. Waiting for admission...'); });
    socket.on('meet_rejected', () => { setStage('rejected'); stream.getTracks().forEach(t => t.stop()); });

    socket.on('meet_user_can_join', ({ socketId, name, avatar }) => {
      const peer = createPeer(socketId, name, stream, socket, true);
      peersRef.current.push({ peerId: socketId, peer, name });
      setPeers(prev => [...prev, { id: socketId, peer, stream: null, name, avatar: avatar || null }]);
      setParticipants(prev => { if (prev.find(p => p.socketId === socketId)) return prev; return [...prev, { name, avatar: avatar || null, socketId }]; });
      toast.success(`${name} joined`);
      // Re-broadcast our mute state to the newly admitted user
      setTimeout(() => {
        socket.emit('meet_mute_state', { meetId, isMuted: isMutedRef.current });
      }, 1000);
    });

    socket.on('meet_user_joined', ({ signal, socketId, name, avatar }) => {
      const existing = peersRef.current.find(p => p.peerId === socketId);
      if (existing) { try { existing.peer.signal(signal); } catch(e) {} return; }
      const peer = createPeer(socketId, name, stream, socket, false, signal);
      peersRef.current.push({ peerId: socketId, peer, name });
      setPeers(prev => [...prev, { id: socketId, peer, stream: null, name, avatar: avatar || null }]);
      setParticipants(prev => { if (prev.find(p => p.socketId === socketId)) return prev; return [...prev, { name, avatar: avatar || null, socketId }]; });
      toast.success(`${name} joined`);
      // Re-broadcast our own mute state so the new joiner knows it
      setTimeout(() => {
        socket.emit('meet_mute_state', { meetId, isMuted: isMutedRef.current });
      }, 1000);
    });

    socket.on('meet_signal', ({ signal, socketId }) => {
      const item = peersRef.current.find(p => p.peerId === socketId);
      if (item) item.peer.signal(signal);
    });

    socket.on('meet_video_stopped', ({ socketId }) => {
      setPeers(prev => prev.map(p => {
        if (p.id !== socketId) return p;
        const audioOnly = p.stream ? new MediaStream(p.stream.getAudioTracks()) : null;
        return { ...p, stream: audioOnly };
      }));
    });

    // When remote peer starts screen share, force video elements to re-attach their stream
    socket.on('meet_screen_share_started', ({ socketId }) => {
      // Track who is sharing so UI switches to share panel layout
      setRemoteSharer(socketId);
      // Force video element re-attach after track settles
      setTimeout(() => {
        setPeers(prev => prev.map(p => {
          if (p.id !== socketId) return p;
          return { ...p, _shareVersion: (p._shareVersion || 0) + 1 };
        }));
      }, 600);
    });

    socket.on('meet_screen_share_stopped', ({ socketId }) => {
      setRemoteSharer(null);
      setPeers(prev => prev.map(p => {
        if (p.id !== socketId) return p;
        return { ...p, _shareVersion: (p._shareVersion || 0) + 1 };
      }));
    });

    socket.on('meet_user_left', ({ socketId, name }) => {
      const item = peersRef.current.find(p => p.peerId === socketId);
      if (item) item.peer.destroy();
      peersRef.current = peersRef.current.filter(p => p.peerId !== socketId);
      setPeers(prev => prev.filter(p => p.id !== socketId));
      setParticipants(prev => prev.filter(p => p.socketId !== socketId));
      setRemoteMuteStates(prev => { const n = {...prev}; delete n[socketId]; return n; });
      setRemoteSharer(prev => prev === socketId ? null : prev);
      stopRemoteSpeakingDetection(socketId);
      if (name) toast(`${name} left`);
    });

    socket.on('meet_mute_state', ({ socketId, isMuted: muted }) => {
      setRemoteMuteStates(prev => ({ ...prev, [socketId]: muted }));
    });

    socket.on('meet_force_mute', () => {
      streamRef.current?.getAudioTracks().forEach(t => { t.enabled = false; });
      setIsMuted(true); isMutedRef.current = true;
      socket.emit('meet_mute_state', { meetId, isMuted: true });
      toast('You were muted by the host', { icon: '🔇' });
    });

    socket.on('meet_kicked', () => {
      toast.error('You were removed from the meeting by the host');
      // Use timeout to escape stale closure — leaveMeeting defined outside joinMeeting
      setTimeout(() => {
        if (streamRef.current) { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; }
        if (lobbyStreamRef.current) { lobbyStreamRef.current.getTracks().forEach(t => t.stop()); lobbyStreamRef.current = null; }
        peersRef.current.forEach(({ peer }) => { try { peer.destroy(); } catch(e) {} });
        peersRef.current = [];
        socket.disconnect();
        clearInterval(timerRef.current);
        setStage('ended');
      }, 500);
    });

    socket.on('meet_waiting_user', ({ socketId, name }) => {
      setWaitingUsers(prev => { if (prev.find(u => u.socketId === socketId)) return prev; return [...prev, { socketId, name }]; });
      toast(`${name} is waiting to join`, { icon: '🚪', duration: 5000 });
    });

    socket.on('meet_chat', msg => {
      setChatMessages(prev => [...prev, msg]);
      if (activePanel !== 'chat') setNewMsgCount(n => n + 1);
    });

    socket.on('meet_recording_started', ({ name }) => {
      toast(`🔴 ${name} started recording`, { duration: 5000, style: { background: '#1a0000', color: '#f87171', border: '1px solid rgba(239,68,68,0.3)' } });
    });

    socket.on('meet_recording_stopped', ({ name }) => {
      toast(`⏹ ${name} stopped recording`, { duration: 4000 });
    });

    socket.on('meet_users', users => {
      setParticipants(prev => {
        const existing = new Set(prev.map(p => p.socketId || p.name));
        const newOnes = users.filter(u => !existing.has(u.socketId)).map(u => ({ name: u.name, avatar: u.avatar || null, socketId: u.socketId }));
        return [...prev, ...newOnes];
      });
      const newPeers = users.map(u => {
        const peer = createPeer(u.socketId, u.name, stream, socket, true);
        peersRef.current.push({ peerId: u.socketId, peer, name: u.name });
        return { id: u.socketId, peer, stream: null, name: u.name, avatar: u.avatar || null };
      });
      setPeers(newPeers);
    });
  };

  const admitUser = (socketId) => { socketRef.current?.emit('meet_admit_user', { meetId, userSocketId: socketId }); setWaitingUsers(prev => prev.filter(u => u.socketId !== socketId)); };
  const rejectUser = (socketId) => { socketRef.current?.emit('meet_reject_user', { meetId, userSocketId: socketId }); setWaitingUsers(prev => prev.filter(u => u.socketId !== socketId)); };

  const kickUser = (socketId) => {
    socketRef.current?.emit('meet_kick_user', { meetId, targetSocketId: socketId });
    setParticipants(prev => prev.filter(p => p.socketId !== socketId));
    setPeers(prev => prev.filter(p => p.id !== socketId));
    const item = peersRef.current.find(p => p.peerId === socketId);
    if (item) item.peer.destroy();
    peersRef.current = peersRef.current.filter(p => p.peerId !== socketId);
    toast.success('User removed from meeting');
  };

  const muteUser = (socketId) => { socketRef.current?.emit('meet_mute_user', { meetId, targetSocketId: socketId }); toast.success('User muted'); };

  const toggleMute = () => {
    const tracks = streamRef.current?.getAudioTracks() || [];
    if (tracks.length === 0) {
      navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, sampleRate: 48000, channelCount: 1 } }).then(s => {
        const newTrack = s.getAudioTracks()[0];
        if (!newTrack || !streamRef.current) return;
        newTrack.enabled = true;
        streamRef.current.addTrack(newTrack);
        peersRef.current.forEach(({ peer }) => {
          try { const sender = peer._pc?.getSenders().find(s => s.track?.kind === 'audio'); if (sender) sender.replaceTrack(newTrack); else peer._pc?.addTrack(newTrack, streamRef.current); } catch(e) {}
        });
        setIsMuted(false); isMutedRef.current = false;
        socketRef.current?.emit('meet_mute_state', { meetId, isMuted: false });
      }).catch(() => {});
      return;
    }
    const newMuted = !isMuted;
    tracks.forEach(t => { t.enabled = !newMuted; });
    setIsMuted(newMuted); isMutedRef.current = newMuted;
    socketRef.current?.emit('meet_mute_state', { meetId, isMuted: newMuted });
  };

  const toggleCam = async () => {
    if (isCamOff) {
      try {
        // Get fresh camera stream
        const ns = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        const nt = ns.getVideoTracks()[0];
        nt.enabled = true;
        // Check if a video sender already exists (black track from join)
        const existingSender = peersRef.current.length > 0
          ? peersRef.current[0].peer._pc?.getSenders().find(s => s.track?.kind === 'video')
          : null;
        if (existingSender) {
          // Sender exists — just replace track (no renegotiation needed)
          streamRef.current?.getVideoTracks().forEach(t => { t.stop(); streamRef.current.removeTrack(t); });
          streamRef.current?.addTrack(nt);
          peersRef.current.forEach(({ peer }) => {
            try {
              const sender = peer._pc?.getSenders().find(s => s.track?.kind === 'video');
              if (sender) sender.replaceTrack(nt);
            } catch(e) {}
          });
        } else {
          // No sender — add track to stream and peers
          streamRef.current?.getVideoTracks().forEach(t => { t.stop(); streamRef.current.removeTrack(t); });
          streamRef.current?.addTrack(nt);
          peersRef.current.forEach(({ peer }) => {
            try { peer._pc?.addTrack(nt, streamRef.current); } catch(e) {}
          });
        }
        // Force peers state refresh so video elements pick up new stream
        setPeers(prev => [...prev]);
        if (myVideoRef.current) myVideoRef.current.srcObject = streamRef.current;
        setIsCamOff(false);
        socketRef.current?.emit('meet_video_started', { meetId });
      } catch(e) { toast.error('Could not restart camera'); }
    } else {
      // Turn cam off — replace with black track to keep sender alive
      let blackTrack = null;
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 640; canvas.height = 480;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = 'black'; ctx.fillRect(0, 0, 640, 480);
        blackTrack = canvas.captureStream(1).getVideoTracks()[0];
        blackTrack.enabled = false;
      } catch(e) {}
      streamRef.current?.getVideoTracks().forEach(t => { t.stop(); streamRef.current.removeTrack(t); });
      if (blackTrack) streamRef.current?.addTrack(blackTrack);
      if (myVideoRef.current) myVideoRef.current.srcObject = null;
      peersRef.current.forEach(({ peer }) => {
        try {
          const sender = peer._pc?.getSenders().find(s => s.track?.kind === 'video');
          if (sender && blackTrack) sender.replaceTrack(blackTrack);
          else if (sender) sender.replaceTrack(null);
        } catch(e) {}
      });
      setIsCamOff(true);
      socketRef.current?.emit('meet_video_stopped', { meetId });
    }
  };

  const stopScreenShare = async () => {
    streamRef.current?.getVideoTracks().forEach(t => { t.stop(); streamRef.current.removeTrack(t); });
    if (myVideoRef.current) myVideoRef.current.srcObject = null;
    let blackTrack = null;
    try { const canvas = document.createElement('canvas'); canvas.width = 2; canvas.height = 2; const ctx = canvas.getContext('2d'); ctx.fillStyle = 'black'; ctx.fillRect(0,0,2,2); blackTrack = canvas.captureStream(1).getVideoTracks()[0]; } catch(e) {}
    peersRef.current.forEach(({ peer }) => {
      try { const sender = peer._pc?.getSenders().find(s => s.track?.kind === 'video'); if (sender) sender.replaceTrack(blackTrack || null); } catch(e) {}
    });
    setIsSharing(false); setIsCamOff(true);
    setRemoteSharer(null);
    socketRef.current?.emit('meet_video_stopped', { meetId });
    socketRef.current?.emit('meet_screen_share_stopped', { meetId });
  };

  const shareScreen = async () => {
    if (isSharing) { await stopScreenShare(); return; }
    try {
      const ss = await navigator.mediaDevices.getDisplayMedia({ video: { cursor: 'always' }, audio: false });
      const st = ss.getVideoTracks()[0];
      st.onended = () => stopScreenShare();
      // Remove existing video tracks from stream
      streamRef.current?.getVideoTracks().forEach(t => { t.stop(); streamRef.current.removeTrack(t); });
      streamRef.current?.addTrack(st);
      // Replace track in all peer senders — sender always exists because we added black track at join
      peersRef.current.forEach(({ peer }) => {
        try {
          const sender = peer._pc?.getSenders().find(s => s.track?.kind === 'video');
          if (sender) {
            sender.replaceTrack(st);
          } else {
            // Fallback: add track directly
            peer._pc?.addTrack(st, streamRef.current);
          }
        } catch(e) { console.warn('replaceTrack screen share error:', e); }
      });
      if (myVideoRef.current) myVideoRef.current.srcObject = streamRef.current;
      setIsSharing(true); setIsCamOff(false);
      socketRef.current?.emit('meet_screen_share_started', { meetId });
    } catch(e) { toast.error('Screen sharing failed or cancelled'); }
  };

  const toggleRecording = async () => {
    if (!isHost) return;
    if (isRecording) {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
        mediaRecorderRef.current.stop();
      }
      clearInterval(recordingTimerRef.current);
      setIsRecording(false);
      setRecordingDuration(0);
      socketRef.current?.emit('meet_recording_stopped', { meetId, name: displayName });
      toast('Recording stopped — file will download shortly');
    } else {
      try {
        // Step 1: Capture the browser tab (video of the meeting UI)
        // This gives us the full meeting view including all participant tiles
        toast('📌 In the popup: select the "Qtalk" tab → click Share to start recording', { duration: 8000 });
        let tabStream = null;
        try {
          tabStream = await navigator.mediaDevices.getDisplayMedia({
            video: { frameRate: 30, cursor: 'always' },
            audio: false // We handle audio separately for better mixing
          });
        } catch(e) {
          toast.error('Please allow screen capture to record the meeting');
          return;
        }

        // Step 2: Mix ALL audio — local mic + all remote participants
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const destination = audioCtx.createMediaStreamDestination();

        // Local mic audio
        if (streamRef.current) {
          const audioTracks = streamRef.current.getAudioTracks();
          if (audioTracks.length > 0) {
            try {
              const localSrc = audioCtx.createMediaStreamSource(streamRef.current);
              localSrc.connect(destination);
            } catch(e) {}
          }
        }

        // All remote participant audio
        peersRef.current.forEach(({ peer }) => {
          try {
            const receivers = peer._pc?.getReceivers() || [];
            receivers.forEach(receiver => {
              if (receiver.track?.kind === 'audio' && receiver.track.readyState === 'live') {
                const remoteStream = new MediaStream([receiver.track]);
                const remoteSrc = audioCtx.createMediaStreamSource(remoteStream);
                remoteSrc.connect(destination);
              }
            });
          } catch(e) {}
        });

        // Step 3: Combine tab video + mixed audio into one stream
        const videoTrack = tabStream.getVideoTracks()[0];
        const audioTrack = destination.stream.getAudioTracks()[0];
        const finalTracks = [];
        if (videoTrack) finalTracks.push(videoTrack);
        if (audioTrack) finalTracks.push(audioTrack);
        const compositeStream = new MediaStream(finalTracks);

        // Stop recording when tab capture ends (user clicks stop in browser)
        videoTrack?.addEventListener('ended', () => {
          if (mediaRecorderRef.current?.state !== 'inactive') {
            mediaRecorderRef.current.stop();
          }
          clearInterval(recordingTimerRef.current);
          setIsRecording(false);
          setRecordingDuration(0);
          socketRef.current?.emit('meet_recording_stopped', { meetId, name: displayName });
        });

        // Step 4: Start MediaRecorder
        const mimeType = ['video/webm;codecs=vp9,opus','video/webm;codecs=vp8,opus','video/webm'].find(t => MediaRecorder.isTypeSupported(t)) || 'video/webm';
        recordedChunksRef.current = [];
        const recorder = new MediaRecorder(compositeStream, { mimeType });
        mediaRecorderRef.current = recorder;

        recorder.ondataavailable = (e) => {
          if (e.data && e.data.size > 0) recordedChunksRef.current.push(e.data);
        };

        recorder.onstop = () => {
          // Stop tab capture stream
          tabStream.getTracks().forEach(t => t.stop());
          try { audioCtx.close(); } catch(e) {}
          // Download the recording
          const blob = new Blob(recordedChunksRef.current, { type: mimeType });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          const now = new Date();
          const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}-${String(now.getMinutes()).padStart(2,'0')}`;
          a.href = url;
          a.download = `Qtalk_Meeting_${meetId}_${ts}.webm`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(url), 5000);
          toast.success('✅ Recording saved to your device!', { duration: 6000 });
        };

        recorder.start(1000);
        setIsRecording(true);
        setRecordingDuration(0);
        recordingTimerRef.current = setInterval(() => setRecordingDuration(d => d + 1), 1000);
        socketRef.current?.emit('meet_recording_started', { meetId, name: displayName });
        toast.success('🔴 Recording started — capturing full meeting view', { duration: 3000 });

      } catch(e) {
        console.error('Recording error:', e);
        toast.error('Recording failed: ' + e.message);
      }
    }
  };

  const leaveMeeting = () => {
    // Stop recording if active
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
    }
    clearInterval(recordingTimerRef.current);
    if (streamRef.current) { streamRef.current.getTracks().forEach(t => t.stop()); streamRef.current = null; }
    if (lobbyStreamRef.current) { lobbyStreamRef.current.getTracks().forEach(t => t.stop()); lobbyStreamRef.current = null; }
    peersRef.current.forEach(({ peer }) => { try { peer.destroy(); } catch(e) {} });
    peersRef.current = [];
    if (myAnalyserRef.current) { clearInterval(myAnalyserRef.current.interval); try { myAnalyserRef.current.ctx.close(); } catch(e) {} }
    Object.keys(analyserRefs.current).forEach(id => stopRemoteSpeakingDetection(id));
    socketRef.current?.disconnect(); socketRef.current = null;
    clearInterval(timerRef.current);
    setStage('ended');
  };

  const sendChat = () => {
    if (!chatInput.trim()) return;
    const msg = { name: displayName, text: chatInput, time: new Date().toLocaleTimeString('en', { hour: '2-digit', minute: '2-digit' }) };
    socketRef.current?.emit('meet_chat', { meetId, ...msg });
    setChatMessages(prev => [...prev, msg]);
    setChatInput('');
  };

  const formatDur = (s) => `${String(Math.floor(s/3600)).padStart(2,'0')}:${String(Math.floor((s%3600)/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;

  const fireReaction = (emoji) => {
    const id = Date.now();
    setRxnFloats(prev => [...prev, { id, emoji }]);
    setTimeout(() => setRxnFloats(prev => prev.filter(r => r.id !== id)), 1400);
  };

  const avatarGradients = ['linear-gradient(135deg,#0d9488,#2563eb)', 'linear-gradient(135deg,#7c3aed,#db2777)', 'linear-gradient(135deg,#ea580c,#d97706)', 'linear-gradient(135deg,#059669,#0891b2)'];
  const getGradient = (name) => avatarGradients[name?.charCodeAt(0) % avatarGradients.length] || avatarGradients[0];

  const AvatarCircle = ({ name, url, size=36, radius=10 }) => {
    const src = url ? (url.startsWith('http') ? url : `https://qtalk.qualtechedge.in${url}`) : null;
    return (
      <div style={{ width:size, height:size, borderRadius:radius, background:getGradient(name), display:'flex', alignItems:'center', justifyContent:'center', fontSize:size*0.38, fontWeight:600, color:'#fff', overflow:'hidden', flexShrink:0 }}>
        {src ? <img src={src} style={{width:'100%',height:'100%',objectFit:'cover'}} alt="" onError={e=>e.target.style.display='none'}/> : (name?.[0]||'?').toUpperCase()}
      </div>
    );
  };

  // ── GUEST NAME ──
  if (stage === 'guest_name') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#0d9488,#1e3a5f)',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{background:'rgba(0,0,0,0.55)',backdropFilter:'blur(20px)',borderRadius:24,padding:40,width:'100%',maxWidth:420,border:'1px solid rgba(255,255,255,0.1)',textAlign:'center'}}>
        <div style={{marginBottom:24}}><div style={{fontSize:26,fontWeight:700,color:'#fff'}}>Qtalk Meet</div><div style={{color:'rgba(255,255,255,0.5)',fontSize:13,marginTop:4}}>Meeting · {meetId}</div></div>
        <div style={{width:72,height:72,borderRadius:'50%',background:'linear-gradient(135deg,#0d9488,#2563eb)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,fontWeight:700,color:'#fff',margin:'0 auto 20px'}}>{guestName?.[0]?.toUpperCase()||'?'}</div>
        <p style={{color:'#fff',fontWeight:600,fontSize:18,margin:'0 0 6px'}}>What's your name?</p>
        <p style={{color:'rgba(255,255,255,0.45)',fontSize:13,margin:'0 0 24px'}}>Joining as a guest</p>
        <input autoFocus type="text" placeholder="Enter your name..." value={guestName} onChange={e=>setGuestName(e.target.value)}
          onKeyDown={e=>{if(e.key==='Enter'&&guestName.trim().length>=2){setGuestNameFinal(guestName.trim());setStage('lobby');}}}
          style={{width:'100%',padding:'13px 16px',borderRadius:12,border:'1.5px solid rgba(255,255,255,0.15)',background:'rgba(255,255,255,0.08)',color:'#fff',fontSize:15,outline:'none',marginBottom:14,boxSizing:'border-box',textAlign:'center'}}/>
        <button onClick={()=>{if(guestName.trim().length<2)return;setGuestNameFinal(guestName.trim());setStage('lobby');}} disabled={guestName.trim().length<2}
          style={{width:'100%',padding:13,borderRadius:12,border:'none',background:guestName.trim().length>=2?'linear-gradient(135deg,#0d9488,#2563eb)':'rgba(255,255,255,0.1)',color:guestName.trim().length>=2?'#fff':'rgba(255,255,255,0.3)',fontSize:14,fontWeight:600,cursor:guestName.trim().length>=2?'pointer':'not-allowed',marginBottom:14}}>
          Continue to Lobby
        </button>
        <div style={{borderTop:'1px solid rgba(255,255,255,0.08)',paddingTop:14}}><a href="/login" style={{color:'#2dd4bf',fontSize:13,fontWeight:600,textDecoration:'none'}}>Sign in to Qtalk →</a></div>
      </div>
    </div>
  );

  // ── LOBBY ──
  if (stage === 'lobby') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#0d9488,#1e3a5f)',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{background:'rgba(0,0,0,0.55)',backdropFilter:'blur(20px)',borderRadius:24,padding:32,width:'100%',maxWidth:480,border:'1px solid rgba(255,255,255,0.1)'}}>
        <div style={{textAlign:'center',marginBottom:22}}>
          <div style={{fontSize:26,fontWeight:700,color:'#fff'}}>Qtalk Meet</div>
          <div style={{color:'rgba(255,255,255,0.55)',fontSize:13,marginTop:4}}>{isHost?'You are the host':`Joining ${meetId}`}</div>
        </div>
        <div style={{position:'relative',borderRadius:14,overflow:'hidden',background:'#000',aspectRatio:'16/9',marginBottom:18}}>
          <video ref={lobbyVideoRef} autoPlay muted playsInline style={{width:'100%',height:'100%',objectFit:'cover',display:lobbyCamOff?'none':'block'}}/>
          {lobbyCamOff&&(<div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:8,background:'#111'}}><div style={{width:60,height:60,borderRadius:'50%',background:'linear-gradient(135deg,#0d9488,#2563eb)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,fontWeight:700,color:'#fff'}}>{displayName[0]?.toUpperCase()}</div><span style={{color:'rgba(255,255,255,0.5)',fontSize:13}}>{displayName}</span></div>)}
          <div style={{position:'absolute',bottom:12,left:'50%',transform:'translateX(-50%)',display:'flex',gap:10}}>
            <button onClick={()=>{if(lobbyStreamRef.current){const t=lobbyStreamRef.current.getAudioTracks()[0];if(t)t.enabled=!lobbyMuted;setLobbyMuted(!lobbyMuted);}}} style={{width:40,height:40,borderRadius:'50%',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',background:lobbyMuted?'#ef4444':'rgba(255,255,255,0.15)'}}>
              <MicIcon muted={lobbyMuted} size={17}/>
            </button>
            <button onClick={async()=>{if(lobbyCamOff){try{const s=await navigator.mediaDevices.getUserMedia({video:true});lobbyStreamRef.current=s;if(lobbyVideoRef.current)lobbyVideoRef.current.srcObject=s;setLobbyCamOff(false);}catch(e){}}else{lobbyStreamRef.current?.getVideoTracks().forEach(t=>t.stop());setLobbyCamOff(true);}}} style={{width:40,height:40,borderRadius:'50%',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',background:lobbyCamOff?'#ef4444':'rgba(255,255,255,0.2)'}}>
              <CamIcon off={lobbyCamOff} size={17}/>
            </button>
          </div>
        </div>
        <div style={{color:'rgba(255,255,255,0.75)',fontSize:13,textAlign:'center',marginBottom:14}}>Ready to join as <strong>{displayName}</strong></div>
        <div style={{marginBottom:14}}>
          <button onClick={()=>setShowBgPicker(!showBgPicker)} style={{width:'100%',padding:8,borderRadius:9,border:'1px solid rgba(255,255,255,0.12)',background:'rgba(255,255,255,0.06)',color:'rgba(255,255,255,0.7)',cursor:'pointer',fontSize:12,display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
            Background Effects {virtualBg!=='none'?`· ${virtualBg}`:''}
          </button>
          {showBgPicker&&(<div style={{marginTop:8,background:'rgba(0,0,0,0.4)',borderRadius:10,padding:10,display:'flex',gap:8,flexWrap:'wrap'}}>{[{id:'none',label:'None',bg:'rgba(255,255,255,0.1)'},{id:'blur',label:'Blur',bg:'rgba(13,148,136,0.3)'},{id:'office',label:'Office',bg:'linear-gradient(135deg,#1e3a5f,#2d6a4f)'},{id:'space',label:'Space',bg:'linear-gradient(135deg,#0a0015,#1a0030)'},{id:'beach',label:'Beach',bg:'linear-gradient(135deg,#006994,#f4a460)'}].map(b=>(<div key={b.id} onClick={()=>setVirtualBg(b.id)} style={{cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:4}}><div style={{width:50,height:36,borderRadius:7,background:b.bg,border:virtualBg===b.id?'2px solid #0d9488':'1.5px solid rgba(255,255,255,0.12)'}}/><span style={{color:'rgba(255,255,255,0.55)',fontSize:10}}>{b.label}</span></div>))}</div>)}
        </div>
        <button onClick={joinMeeting} style={{width:'100%',padding:13,borderRadius:12,border:'none',cursor:'pointer',fontSize:14,fontWeight:600,background:'linear-gradient(135deg,#0d9488,#2563eb)',color:'#fff'}}>
          {isHost?'Start Meeting':'Join Meeting'}
        </button>
        <div style={{textAlign:'center',marginTop:10,color:'rgba(255,255,255,0.35)',fontSize:11}}>🔒 End-to-end encrypted · Qtalk Meet</div>
        <div style={{textAlign:'center',marginTop:6,fontSize:10,color:'rgba(245,158,11,0.8)',fontWeight:600}}>⚠️ Beta — Video & screen share may have issues</div>
      </div>
    </div>
  );

  // ── WAITING ──
  if (stage === 'waiting') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#0d9488,#1e3a5f)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'rgba(0,0,0,0.55)',backdropFilter:'blur(20px)',borderRadius:24,padding:40,textAlign:'center',border:'1px solid rgba(255,255,255,0.1)',maxWidth:380}}>
        <div style={{width:64,height:64,borderRadius:'50%',background:'linear-gradient(135deg,#0d9488,#2563eb)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,margin:'0 auto 20px'}}>⏳</div>
        <h2 style={{color:'#fff',fontSize:22,fontWeight:700,marginBottom:8}}>Waiting to be admitted</h2>
        <p style={{color:'rgba(255,255,255,0.55)',fontSize:14,marginBottom:24}}>{hostJoined?'The host will let you in soon...':'Waiting for the host to start...'}</p>
        <div style={{display:'flex',gap:8,justifyContent:'center',marginBottom:24}}>{[0,1,2].map(i=>(<div key={i} style={{width:10,height:10,borderRadius:'50%',background:'#0d9488',opacity:0.4,animation:`pulse ${0.8+i*0.2}s ease-in-out infinite alternate`}}/>))}</div>
        <button onClick={()=>{streamRef.current?.getTracks().forEach(t=>t.stop());socketRef.current?.disconnect();setStage('lobby');}} style={{padding:'9px 22px',borderRadius:10,border:'1.5px solid rgba(255,255,255,0.25)',background:'transparent',color:'#fff',cursor:'pointer',fontSize:13,fontWeight:600}}>Cancel</button>
        <style>{`@keyframes pulse{from{opacity:0.2;transform:scale(0.8)}to{opacity:1;transform:scale(1.2)}}`}</style>
      </div>
    </div>
  );

  // ── REJECTED ──
  if (stage === 'rejected') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#7f1d1d,#1e3a5f)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'rgba(0,0,0,0.55)',backdropFilter:'blur(20px)',borderRadius:24,padding:40,textAlign:'center',border:'1px solid rgba(255,255,255,0.1)',maxWidth:380}}>
        <div style={{fontSize:48,marginBottom:16}}>🚫</div>
        <h2 style={{color:'#fff',fontSize:22,fontWeight:700,marginBottom:8}}>Entry Denied</h2>
        <p style={{color:'rgba(255,255,255,0.55)',fontSize:14,marginBottom:24}}>The host did not admit you to this meeting.</p>
        <a href="/chat" style={{display:'inline-block',padding:'10px 22px',borderRadius:10,background:'linear-gradient(135deg,#0d9488,#2563eb)',color:'#fff',textDecoration:'none',fontSize:14,fontWeight:600}}>Back to Qtalk</a>
      </div>
    </div>
  );

  // ── ENDED ──
  if (stage === 'ended') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#0d9488,#1e3a5f)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'rgba(0,0,0,0.55)',backdropFilter:'blur(20px)',borderRadius:24,padding:40,textAlign:'center',border:'1px solid rgba(255,255,255,0.1)',maxWidth:380}}>
        <div style={{fontSize:48,marginBottom:16}}>👋</div>
        <h2 style={{color:'#fff',fontSize:22,fontWeight:700,marginBottom:8}}>Meeting Ended</h2>
        <p style={{color:'rgba(255,255,255,0.55)',fontSize:14,marginBottom:8}}>Duration: {formatDur(duration)}</p>
        <p style={{color:'rgba(255,255,255,0.35)',fontSize:13,marginBottom:24}}>{participants.length} participant{participants.length!==1?'s':''}</p>
        <a href="/chat" style={{display:'inline-block',padding:'11px 26px',borderRadius:10,background:'linear-gradient(135deg,#0d9488,#2563eb)',color:'#fff',textDecoration:'none',fontSize:14,fontWeight:600}}>Back to Qtalk</a>
      </div>
    </div>
  );

  // ── MEETING ──
  const allVideos = [
    { id:'me', name:`${displayName} (You)`, isMe:true, avatar:user?.avatar_url||null },
    ...peers.map(p => ({ id:p.id, name:p.name, stream:p.stream, isMe:false, avatar:p.avatar||null }))
  ];
  const total = allVideos.length;
  const cols = total<=1?1:total<=2?2:total<=4?2:total<=6?3:total<=9?3:4;
  const rows = Math.ceil(total/cols);
  const sharingPeer = isSharing ? 'me' : remoteSharer || null;
  const shareName = sharingPeer==='me' ? displayName : allVideos.find(v=>v.id===sharingPeer)?.name || '';
  const speakRing = (id) => speaking[id] ? { outline:'2px solid #0d9488', outlineOffset:0 } : {};

  const TileNameBar = ({ v }) => {
    const sid = v.isMe ? 'me' : v.id;
    const muted = v.isMe ? isMuted : remoteMuteStates[v.id];
    const spk = speaking[sid];
    return (
      <div style={{position:'absolute',bottom:6,left:8,right:8,display:'flex',alignItems:'center',justifyContent:'space-between',zIndex:2}}>
        <div style={{display:'flex',alignItems:'center',gap:4}}>
          <div style={{width:18,height:18,borderRadius:'50%',background:muted?'rgba(239,68,68,0.85)':spk?'rgba(13,148,136,0.9)':'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',animation:spk&&!muted?'speakPulse 0.5s ease-in-out infinite':'none',transition:'background 0.1s'}}>
            <MicIcon muted={muted} size={9}/>
          </div>
          <div style={{background:'rgba(0,0,0,0.65)',borderRadius:5,padding:'2px 6px',fontSize:11,color:'#fff',fontWeight:500}}>{v.name}</div>
        </div>
      </div>
    );
  };

  return (
    <div style={S.root}>
      <style>{`
        @keyframes pulse{from{opacity:0.2;transform:scale(0.8)}to{opacity:1;transform:scale(1.2)}}
        @keyframes speakPulse{0%{transform:scale(1)}50%{transform:scale(1.12)}100%{transform:scale(1)}}
        @keyframes floatUp{0%{opacity:1;transform:translateX(-50%) translateY(0) scale(1)}100%{opacity:0;transform:translateX(-50%) translateY(-44px) scale(1.5)}}
        @keyframes recBlink{0%,100%{opacity:1}50%{opacity:0.3}}
        .pop-item:hover{background:#21262d!important;color:#e6edf3!important}
        .hdr-btn-h:hover{background:#21262d!important;color:#e6edf3!important}
        .ctrl-b:hover{background:#2d333b!important}
        .ptab-h:hover{color:#e6edf3!important}
        .sc-btn-h:hover{background:#2d333b!important;color:#e6edf3!important}
        .thumb-h:hover{border-color:rgba(255,255,255,0.2)!important}
        .pc-action:hover{background:#2d333b!important}
        .wait-admit:hover{opacity:0.85}
        .wait-deny:hover{background:rgba(239,68,68,0.5)!important}
      `}</style>

      {/* Reaction floaters */}
      {rxnFloats.map(r => (
        <div key={r.id} style={{position:'fixed',bottom:110,left:'50%',fontSize:24,zIndex:999,animation:'floatUp 1.4s ease forwards',pointerEvents:'none'}}>{r.emoji}</div>
      ))}

      {/* ── HEADER ── */}
      <div style={S.hdr}>
        <div style={S.hdrLeft}>
          <div style={S.logoMark}>
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{width:14,height:14}}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
          </div>
          <span style={S.logoText}>Qtalk Meet</span>
          <span style={{fontSize:9,fontWeight:700,background:'#f59e0b',color:'white',padding:'1px 5px',borderRadius:4,marginLeft:4,letterSpacing:'0.03em'}}>BETA</span>
          <span style={{...S.meetIdText, marginLeft:2}}>· {meetId}</span>
        </div>

        <div style={S.hdrCenter}>
          <div style={S.durText}>{formatDur(duration)}</div>
          <div style={S.pcountText}>{participants.length} participant{participants.length!==1?'s':''}</div>
        </div>

        <div style={S.hdrRight}>
          {isHost && waitingUsers.length > 0 && (
            <div onClick={()=>setActivePanel('people')} style={{display:'flex',alignItems:'center',gap:4,background:'#ef4444',borderRadius:10,padding:'3px 8px',cursor:'pointer'}}>
              <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{width:11,height:11}}><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              <span style={{color:'#fff',fontSize:11,fontWeight:700}}>{waitingUsers.length} waiting</span>
            </div>
          )}
          <div style={{display:'flex',alignItems:'center',gap:5,padding:'4px 10px',borderRadius:7,border:'1px solid rgba(13,148,136,0.25)',background:'rgba(13,148,136,0.06)',cursor:'default',userSelect:'none'}}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:11,height:11}}><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            <span style={{fontSize:11,fontWeight:500,color:'#0d9488',letterSpacing:'0.02em'}}>QualTechEdge</span>
          </div>
          {isHost && (
            <button className="hdr-btn-h" onClick={toggleRecording}
              style={{display:'flex',alignItems:'center',gap:5,padding:'5px 10px',borderRadius:7,border:isRecording?'1px solid rgba(239,68,68,0.5)':'1px solid rgba(255,255,255,0.08)',background:isRecording?'rgba(239,68,68,0.12)':'transparent',color:isRecording?'#f87171':'#8b949e',cursor:'pointer',fontSize:11,fontWeight:500}}>
              <div style={{width:6,height:6,borderRadius:'50%',background:isRecording?'#ef4444':'#6e7681',animation:isRecording?'recBlink 1.4s infinite':'none',flexShrink:0}}/>
              {isRecording ? `Recording ${String(Math.floor(recordingDuration/60)).padStart(2,'0')}:${String(recordingDuration%60).padStart(2,'0')}` : 'Record'}
            </button>
          )}
          {!isHost && isRecording && (
            <div style={{display:'flex',alignItems:'center',gap:5,padding:'4px 10px',borderRadius:7,border:'1px solid rgba(239,68,68,0.3)',background:'rgba(239,68,68,0.08)',cursor:'default'}}>
              <div style={{width:6,height:6,borderRadius:'50%',background:'#ef4444',animation:'recBlink 1.4s infinite',flexShrink:0}}/>
              <span style={{fontSize:11,color:'#f87171'}}>Recording</span>
            </div>
          )}
        </div>
      </div>

      {/* Hidden audio */}
      {peers.map(p => p.stream && (
        <audio key={p.id} autoPlay playsInline ref={el=>{if(el&&p.stream){el.srcObject=p.stream;el.volume=1;el.muted=false;}}} style={{display:'none'}}/>
      ))}

      {/* ── BODY ── */}
      <div style={S.body}>

        {/* ── MAIN ── */}
        <div style={sharingPeer ? S.mainSharing : S.main}>

          {/* Screen share panel OR grid */}
          {sharingPeer ? (
            <>
              <div style={S.sharePanel}>
                <div style={S.sharePanelHeader}>
                  <div style={{display:'flex',alignItems:'center'}}>
                    <span style={S.shareBadge}>Screen Share Active</span>
                    <span style={S.shareName}>{shareName}</span>
                  </div>
                  <div style={{display:'flex',gap:4}}>
                    {[
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:11,height:11}}><path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3M3 16v3a2 2 0 002 2h3m8 0h3a2 2 0 002-2v-3"/></svg>,
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:11,height:11}}><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>,
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:11,height:11}}><path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4z"/></svg>
                    ].map((icon,i) => (
                      <div key={i} className="sc-btn-h" style={S.shareCtrlBtn}>{icon}</div>
                    ))}
                  </div>
                </div>
                <div style={S.shareVideo}>
                  {sharingPeer==='me'
                    ? <video ref={myVideoRef} autoPlay muted playsInline style={{width:'100%',height:'100%',objectFit:'contain'}}/>
                    : <video ref={el=>{if(el&&el!==sharePanelVideoRef.current){sharePanelVideoRef.current=el;const p=peers.find(x=>x.id===sharingPeer);if(p?.stream&&el.srcObject!==p.stream){el.srcObject=p.stream;el.muted=false;el.play().catch(()=>{});}}}} autoPlay playsInline style={{width:'100%',height:'100%',objectFit:'contain'}}/>
                  }
                </div>
              </div>

              {/* Thumbnail strip */}
              <div style={S.thumbStripV}>
                {allVideos.map(v => {
                  const sid = v.isMe?'me':v.id;
                  const muted = v.isMe?isMuted:remoteMuteStates[v.id];
                  const camOff = v.isMe?isCamOff:!v.stream?.getVideoTracks()?.length;
                  return (
                    <div key={v.id} className="thumb-h" style={{...S.thumbV, ...speakRing(sid)}}>
                      <div style={S.thumbBadge}>
                        {muted && <div style={{...S.tIcon,background:'rgba(239,68,68,0.2)'}}><MicIcon muted={true} size={8}/></div>}
                        {(v.isMe?isCamOff:camOff) && <div style={{...S.tIcon,background:'rgba(100,100,100,0.2)'}}><CamIcon off={true} size={8}/></div>}
                      </div>
                      <AvatarCircle name={v.name} url={v.avatar} size={32} radius={8}/>
                      <div style={S.thumbName}>{v.name}</div>
                      {v.isMe && isSharing && <div style={{fontSize:9,color:'#0d9488',marginTop:-3}}>sharing</div>}
                      {v.isMe
                        ? <video ref={myVideoRef} autoPlay muted playsInline style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',transform:'scaleX(-1)',display:isCamOff?'none':'block',zIndex:1,borderRadius:10}}/>
                        : <video autoPlay playsInline style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',zIndex:1,borderRadius:10}} ref={el=>{const p=peers.find(x=>x.id===v.id);if(el&&p?.stream){el.srcObject=p.stream;el.muted=false;el.play().catch(()=>{});const vt=p.stream.getVideoTracks();el.style.display=(vt.length&&vt.some(t=>t.enabled&&t.readyState==='live'))?'block':'none';}}}/>
                      }
                    </div>
                  );
                })}
                <div className="thumb-h" style={{...S.thumbV,borderStyle:'dashed',opacity:0.45}} onClick={()=>toast('Invite link copied!')}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#8b949e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{width:18,height:18}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                  <div style={S.thumbName}>Invite</div>
                </div>
              </div>
            </>
          ) : (
            <div style={{...S.gridWrap, gridTemplateColumns:`repeat(${cols},1fr)`, gridTemplateRows:`repeat(${rows},1fr)`, flex:1}}>
              {allVideos.map(v => {
                const sid = v.isMe?'me':v.id;
                const muted = v.isMe?isMuted:remoteMuteStates[v.id];
                return (
                  <div key={v.id} style={{...S.gridTile, ...speakRing(sid)}}>
                    <div style={S.tileAvatar}>
                      <AvatarCircle name={v.name} url={v.avatar} size={total===1?80:56} radius={total===1?40:28}/>
                      <span style={{color:'rgba(255,255,255,0.55)',fontSize:12}}>{v.name.replace(' (You)','')}</span>
                    </div>
                    {v.isMe
                      ? <video ref={myVideoRef} autoPlay muted playsInline style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',transform:'scaleX(-1)',display:isCamOff?'none':'block',zIndex:1}}/>
                      : <video autoPlay playsInline style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',zIndex:1}}
                          ref={el=>{
                            if(!el || !v.stream) return;
                            // Always re-assign — replaceTrack changes tracks inside same stream object
                            el.srcObject = v.stream;
                            el.muted = false; el.volume = 1;
                            el.play().catch(()=>{});
                            const vt = v.stream.getVideoTracks();
                            el.style.display = (vt.length && vt.some(t=>t.enabled && t.readyState==='live')) ? 'block' : 'none';
                          }}/>
                    }
                    <TileNameBar v={v}/>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* ── RIGHT PANEL ── */}
        {activePanel && (
          <div style={S.rightPanel}>
            <div style={S.panelTabs}>
              {[
                { id:'people', label:`People (${participants.length})` },
                { id:'chat', label:'Chat', badge: newMsgCount }
              ].map(tab => (
                <div key={tab.id} className="ptab-h" onClick={()=>{ setActivePanel(tab.id); if(tab.id==='chat') setNewMsgCount(0); }}
                  style={{flex:1,padding:'9px 0',textAlign:'center',fontSize:11,fontWeight:500,cursor:'pointer',borderBottom:activePanel===tab.id?'2px solid #0d9488':'2px solid transparent',color:activePanel===tab.id?'#0d9488':'#8b949e',position:'relative',transition:'all 0.15s'}}>
                  {tab.label}
                  {tab.badge>0&&<span style={{position:'absolute',top:6,right:12,background:'#ef4444',borderRadius:'50%',width:14,height:14,fontSize:8,fontWeight:700,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center'}}>{tab.badge}</span>}
                </div>
              ))}
              <div onClick={()=>setActivePanel(null)} style={{padding:'9px 10px',cursor:'pointer',color:'#6e7681',display:'flex',alignItems:'center'}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:14,height:14}}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>

            {activePanel==='people' && (
              <div style={{flex:1,overflowY:'auto',padding:12}}>
                <div style={{fontSize:10,fontWeight:600,color:'#6e7681',letterSpacing:'0.06em',textTransform:'uppercase',marginBottom:10}}>In Meeting</div>
                {participants.map((p,i) => {
                  const pName = typeof p==='string'?p:p.name;
                  const pAvatar = typeof p==='object'?p.avatar:null;
                  const pSocketId = typeof p==='object'?p.socketId:null;
                  const isMe = pSocketId==='me';
                  const isMutedRemote = !isMe&&remoteMuteStates[pSocketId];
                  const isSpeaking = speaking[isMe?'me':pSocketId];
                  const isHostCard = isMe;
                  return (
                    <div key={i} style={isHostCard?S.pcardHost:S.pcard}>
                      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                        <div style={{position:'relative'}}>
                          <AvatarCircle name={pName} url={pAvatar} size={36} radius={10}/>
                          <div style={{position:'absolute',bottom:-1,right:-1,width:9,height:9,borderRadius:'50%',background:'#0d9488',border:'2px solid #21262d'}}/>
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={S.pcName}>{pName}</div>
                          <div style={S.pcRole}>{isMe?'You':''}</div>
                        </div>
                        <div style={{display:'flex',gap:4,flexShrink:0}}>
                          {(isMe?isMuted:isMutedRemote) && (
                            <div style={{width:16,height:16,borderRadius:'50%',background:'rgba(239,68,68,0.8)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                              <MicIcon muted={true} size={8}/>
                            </div>
                          )}
                          {isHost&&!isMe&&pSocketId&&(
                            <>
                              <button className="pc-action" onClick={()=>muteUser(pSocketId)} title="Mute" style={{width:22,height:22,borderRadius:5,border:'none',background:'rgba(255,255,255,0.08)',color:'#8b949e',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                <MicIcon muted={true} size={9}/>
                              </button>
                              <button className="pc-action" onClick={()=>kickUser(pSocketId)} title="Remove" style={{width:22,height:22,borderRadius:5,border:'none',background:'rgba(239,68,68,0.15)',color:'#f87171',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:9,height:9}}><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                      <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                        {isHostCard&&<span style={{...S.badge,background:'rgba(13,148,136,0.15)',color:'#0d9488'}}>Host</span>}
                        {isSharing&&isMe&&<span style={{...S.badge,background:'rgba(37,99,235,0.15)',color:'#60a5fa'}}>Sharing Screen</span>}
                        {(isMe?isMuted:isMutedRemote)&&<span style={{...S.badge,background:'rgba(239,68,68,0.12)',color:'#f87171'}}>Muted</span>}
                        {isSpeaking&&!(isMe?isMuted:isMutedRemote)&&<span style={{...S.badge,background:'rgba(13,148,136,0.12)',color:'#34d399'}}>Speaking</span>}
                      </div>
                    </div>
                  );
                })}

                {isHost&&waitingUsers.length>0&&(
                  <div style={{marginTop:14}}>
                    <div style={{fontSize:10,fontWeight:600,color:'#f87171',letterSpacing:'0.06em',textTransform:'uppercase',marginBottom:8}}>Waiting · {waitingUsers.length}</div>
                    <div style={{maxHeight:200,overflowY:'auto',display:'flex',flexDirection:'column',gap:7}}>
                      {waitingUsers.map(u=>(
                        <div key={u.socketId} style={S.waitCard}>
                          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:7}}>
                            <div style={S.waitAvatar}>{u.name[0]?.toUpperCase()}</div>
                            <div>
                              <div style={{fontSize:12,fontWeight:500,color:'#e6edf3'}}>{u.name}</div>
                              <div style={{fontSize:10,color:'#8b949e'}}>Wants to join</div>
                            </div>
                          </div>
                          <div style={{display:'flex',gap:5}}>
                            <button className="wait-admit" onClick={()=>admitUser(u.socketId)} style={{...S.wBtn,background:'#0d9488',color:'#fff'}}>Admit</button>
                            <button className="wait-deny" onClick={()=>rejectUser(u.socketId)} style={{...S.wBtn,background:'rgba(239,68,68,0.3)',color:'#f87171'}}>Deny</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {activePanel==='chat' && (
              <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden'}}>
                <div style={{flex:1,overflowY:'auto',padding:12,display:'flex',flexDirection:'column',gap:8}}>
                  {chatMessages.length===0&&<div style={{color:'rgba(255,255,255,0.2)',fontSize:12,textAlign:'center',marginTop:28}}>No messages yet</div>}
                  {chatMessages.map((m,i)=>(
                    <div key={i} style={{background:'rgba(255,255,255,0.04)',borderRadius:8,padding:'8px 10px',border:'1px solid rgba(255,255,255,0.06)'}}>
                      <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:3}}>
                        <span style={{color:'#0d9488',fontSize:11,fontWeight:600}}>{m.name}</span>
                        <span style={{color:'#6e7681',fontSize:10}}>{m.time}</span>
                      </div>
                      <div style={{color:'#e6edf3',fontSize:12,lineHeight:1.5}}>{m.text}</div>
                    </div>
                  ))}
                  <div ref={chatEndRef}/>
                </div>
                <div style={{padding:10,borderTop:'1px solid rgba(255,255,255,0.08)',display:'flex',gap:6,flexShrink:0}}>
                  <input value={chatInput} onChange={e=>setChatInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendChat()} placeholder="Message everyone..."
                    style={{flex:1,background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:7,padding:'7px 10px',color:'#e6edf3',fontSize:12,outline:'none'}}/>
                  <button onClick={sendChat} style={{padding:'7px 10px',borderRadius:7,border:'none',background:'#0d9488',color:'#fff',cursor:'pointer',fontWeight:600}}>
                    <svg viewBox="0 0 24 24" fill="currentColor" style={{width:13,height:13}}><path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"/></svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── REACTIONS BAR ── */}
      <div style={S.rxnBar}>
        <span style={{fontSize:10,color:'#6e7681',marginRight:4}}>React</span>
        {['👍','👏','❤️','😄','🙋'].map(emoji=>(
          <button key={emoji} style={S.rxnBtn} onClick={()=>fireReaction(emoji)}
            onMouseEnter={e=>e.currentTarget.style.transform='scale(1.12)'}
            onMouseLeave={e=>e.currentTarget.style.transform='scale(1)'}>
            {emoji}
          </button>
        ))}
        <div style={{flex:1}}/>
        <span style={{fontSize:10,color:'#6e7681'}}>🔒 End-to-end encrypted</span>
      </div>

      {/* ── CONTROLS ── */}
      <div style={S.controls}>
        {/* Mute */}
        <button className="ctrl-b" onClick={toggleMute} style={isMuted?S.ctrlBtnActive:S.ctrlBtn}>
          <MicIcon muted={isMuted} size={17}/>
          <span style={S.ctrlLabel}>{isMuted?'Unmute':'Mute'}</span>
        </button>

        {/* Camera */}
        <button className="ctrl-b" onClick={toggleCam} style={isCamOff?S.ctrlBtnActive:S.ctrlBtn}>
          <CamIcon off={isCamOff} size={17}/>
          <span style={S.ctrlLabel}>{isCamOff?'Start Video':'Stop Video'}</span>
        </button>

        {/* Screen share */}
        <button className="ctrl-b" onClick={shareScreen} style={isSharing?S.ctrlBtnShare:S.ctrlBtn}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:17,height:17}}><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
          <span style={S.ctrlLabel}>{isSharing?'Stop Share':'Share Screen'}</span>
        </button>

        <div style={S.ctrlDivider}/>

        {/* People */}
        <button className="ctrl-b" onClick={()=>setActivePanel(activePanel==='people'?null:'people')} style={activePanel==='people'?{...S.ctrlBtn,background:'rgba(13,148,136,0.15)',color:'#0d9488'}:S.ctrlBtn}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:17,height:17}}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
          <span style={S.ctrlLabel}>People</span>
        </button>

        {/* Chat */}
        <button className="ctrl-b" onClick={()=>{ setActivePanel(activePanel==='chat'?null:'chat'); setNewMsgCount(0); }} style={activePanel==='chat'?{...S.ctrlBtn,background:'rgba(13,148,136,0.15)',color:'#0d9488',position:'relative'}:{...S.ctrlBtn,position:'relative'}}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:17,height:17}}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
          <span style={S.ctrlLabel}>Chat</span>
          {newMsgCount>0&&<span style={{position:'absolute',top:4,right:4,background:'#ef4444',borderRadius:'50%',width:14,height:14,fontSize:8,fontWeight:700,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center'}}>{newMsgCount}</span>}
        </button>

        {/* Enterprise Tools */}
        <div style={{position:'relative'}} ref={entPopRef}>
          <button className="ctrl-b" onClick={()=>setShowEntPop(!showEntPop)} style={showEntPop?{...S.ctrlBtn,background:'rgba(13,148,136,0.15)',color:'#0d9488'}:S.ctrlBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:17,height:17}}><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            <span style={S.ctrlLabel}>Tools</span>
          </button>
          {showEntPop&&(
            <div style={{...S.popover,left:-20}}>
              {[
                { icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>, label:'Whiteboard' },
                { icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>, label:'Breakout Rooms' },
                { icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>, label:'Transcription' },
                { icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>, label:'Polls' },
              ].map((item,i)=>(
                <div key={i} className="pop-item" style={S.popItem} onClick={()=>{ toast(`${item.label} — coming soon`); setShowEntPop(false); }}>
                  {item.icon}{item.label}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={S.ctrlDivider}/>

        {/* Leave */}
        <button onClick={leaveMeeting} style={S.leaveBtn}>
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:15,height:15}}><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          Leave
        </button>
      </div>
    </div>
  );
}
